export const myHostname = () => {  
  return window.location.hostname.includes("localhost") ? "labels.ezilabels.com" : window.location.hostname;
};